/* SAVID long-form policy behaviour.
 *
 * Two interactions, both reproducing WooCommerce:
 *   .privacy-accordion  one collapsible item per section, all closed
 *                       on load, "+" / "-" affordance on the right
 *   .svd-tabs           a rail of tabs and one visible panel
 */
(function () {
  /* ---------- accordion ---------- */
  document.querySelectorAll('[data-savid-accordion]').forEach(function (acc) {
    acc.querySelectorAll('.privacy-item').forEach(function (item) {
      var head = item.querySelector('.privacy-title');
      var body = item.querySelector('.privacy-content');
      if (!head || !body) return;
      head.addEventListener('click', function () {
        var open = item.classList.toggle('active');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        body.hidden = !open;
      });
    });
  });

  /* ---------- tabs ---------- */
  document.querySelectorAll('[data-savid-tabs]').forEach(function (wrap) {
    var tabs = Array.prototype.slice.call(wrap.querySelectorAll('.svd-tab'));
    var panels = Array.prototype.slice.call(wrap.querySelectorAll('.svd-panel'));

    function select(i) {
      tabs.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p, n) {
        var on = n === i;
        p.classList.toggle('is-active', on);
        p.hidden = !on;
      });
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (ev) {
        var next = null;
        if (ev.key === 'ArrowDown' || ev.key === 'ArrowRight') next = (i + 1) % tabs.length;
        if (ev.key === 'ArrowUp' || ev.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        if (ev.key === 'Home') next = 0;
        if (ev.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        ev.preventDefault();
        select(next);
        tabs[next].focus();
      });
    });

    if (tabs.length) select(0);
  });
})();
